import { Tooltip } from "antd"
import cls from "classname"

import Icon from "../../../Icon"

export const tooltipTitle = {
  critical:
    "If your balance drops to this level, your account will be unenrolled and services will stop",
  min: "This is the lowest safe balance you should keep to avoid unexpected interruptions",
  rec: "Staying above this point ensures continuous service reliability without frequent top-ups"
}

export const CircleInfoInfoCircleTooltipInformation = ({ title, isDanger, ...props }) => (
  <Tooltip title={title} {...props}>
    <div className="info-tooltip">
      <Icon className={cls({ "info-danger": isDanger })} type="circle_info" />
    </div>
  </Tooltip>
)

export const PAYMENT_METHODS = {
  STRIPE: "stripe",
  SHOPIFY: "shopify",
  ADYEN: "adyen"
}
